import { createContext, useContext, type ReactNode } from "react";
import {
  type PacksSectionInput,
  usePacksSectionState,
} from "./use-packs-section-state";

type PacksSectionValue = ReturnType<typeof usePacksSectionState>;

const PacksSectionContext = createContext<PacksSectionValue | null>(null);

export const PacksSectionProvider = ({
  children,
  ...input
}: PacksSectionInput & { children: ReactNode }) => {
  const value = usePacksSectionState(input);

  return (
    <PacksSectionContext.Provider value={value}>
      {children}
    </PacksSectionContext.Provider>
  );
};

export const usePacksSection = () => {
  const section = useContext(PacksSectionContext);
  if (!section) {
    throw new Error(
      "PayPacks components must be rendered inside a PacksSectionProvider.",
    );
  }
  return section;
};
